export const CYRILLIC_SYMBOLS_REG_EXP = /[а-яё]/gi;

export const InputMinLength = {
  NAME: 2,
  TEXT: 3,
};
